import React, {
  useRef,
  useState,
  useEffect,
} from 'react';
import Player from '@vimeo/player';
import i18n from 'i18next';

import {
  Flex,
  Text,
  SVG,
} from 'web-styled';

import * as S from './styled';

type Props = {
  /* video url */
  src: string,
  title?: string,
  width?: string,
  height?: string,
  isRounded: boolean,
};

const VideoFrame = ({
  src,
  title = '',
  width = '400px',
  height = '400px',
  isRounded,
}: Props) => {
  const ref = useRef<HTMLDivElement>(null);
  const iframe = useRef<HTMLIFrameElement>(null);
  const isVimeo = src && src.indexOf('vimeo') !== -1;
  const [videoState, setVideoState] = useState({
    available: !isVimeo,
  });

  useEffect(() => {
    function replaceSrc() {
      setVideoState({
        available: true,
      });
      iframe?.current?.contentWindow?.location.replace(src);
    }
    if (!src) {
      setVideoState({
        error: true,
        processing: true,
      });
    } else if (src && isVimeo && ref) {
      const player = new Player(ref.current, { url: src });
      player.on('loaded', () => {
        replaceSrc();
      });
      player.on('error', () => {
        console.log('VideoFrame load error');
        setVideoState({
          error: false,
          processing: true,
        });
      });
    } else if (src) {
      replaceSrc();
    } else {
      setVideoState({
        error: true,
      });
    }
  }, [src]);

  return (
    <Flex
      column
      width={width}
      height={height}
      noPrint
    >
      {isVimeo && (
        <iframe
          src={src}
          hidden
          ref={ref}
          title="title"
          frameBorder="0"
        />
      )}

      <S.Video
        style={{
          display: videoState.available ? 'flex' : 'none',
        }}
      >
        <S.Frame
          src="about:blank"
          ref={iframe}
          title={title}
          loading="lazy"
          allowFullScreen=""
        />
      </S.Video>

      {videoState.error && (
        <S.Placeholder isRounded={isRounded}>
          <S.PlaceholderIcon>
            <SVG.PlayFilled size={30} />
          </S.PlaceholderIcon>
          <Text whiteSpace="pre-line">
            {i18n.t('video.processing')}
          </Text>
        </S.Placeholder>
      )}
    </Flex>
  );
};

export default VideoFrame;
